import { ReceivingDebtComponent } from "../../../components/borrowSystem/Contact/ReceivingDebtComponent"
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
export function ReceivingDebtContainer () {
    const titleName = "รายการได้รับการชำระหนี้คืน";
    return(
        <div className="page-container bg-landing">
            <NavbarBorrowSystem  />
            <HeadTitle title={titleName} />
            <ReceivingDebtComponent/>
            <Footer />
        </div>   
    )
}